import React from 'react';

import { IImportAssetComponent } from '@interfaces/components/form';

interface IImportAssetProps {
	components: Array<IImportAssetComponent>;
	importIds: string[];
	toggleCloseConfirmModal: () => void;
	setCurrentComponent: React.Dispatch<React.SetStateAction<string>>;
	currentComponent: string;
}

const ImportMapData = ({
	components,
	importIds,
	toggleCloseConfirmModal,
	setCurrentComponent,
	currentComponent,
}: IImportAssetProps) => {
	const generateComponent = (index: number) => {
		const Component = components[index].component;
		const props = components[index].props;

		return (
			<Component
				importIds={importIds}
				onClose={toggleCloseConfirmModal}
				setCurrentComponent={setCurrentComponent}
				{...props}
			/>
		);
	};

	const getCurrentComponent = () => {
		switch (currentComponent) {
			case components[0].value:
				return generateComponent(0);
			case components[1].value:
				return generateComponent(1);
			case components[2].value:
				return generateComponent(2);
			case components[3].value:
				return generateComponent(3);
			default:
				return generateComponent(0);
		}
	};

	return getCurrentComponent();
};

export default ImportMapData;
